<template>
  <div class="flex flex-col h-screen">
    <mainHeader />
    <div class="page-content pb-auto">
      <div class="wrapper">
        <router-view />
      </div>
    </div>
    <mainFooter />
  </div>
</template>

<script>
import mainHeader from '@/components/mainHeader.vue';
import mainFooter from '@/components/mainFooter.vue';

export default {
  name: 'default',
  components: { mainHeader, mainFooter },
};
</script>
